import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import React from "react";
import {CardActionArea, Typography} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import {useTheme} from "../../contexts/theme";

export default function KeyMomentViewer({clips, handleChangeClip, clipSelected}) {
    const theme = useTheme();

    return (
        <Box width={'100%'}>
            {
               clips.map((clip, index) => (
                   <Card
                       sx={{
                           marginBottom: theme.spacing.sm,
                           backgroundColor: theme.palette.blue,
                           color: theme.palette.white,
                           borderRadius: 2, // bordi arrotondati (2 = 16px se usi il default theme spacing)
                           boxShadow: theme.spacing.xl, // ombra di profondità 3
                       }}
                   >
                       <CardActionArea
                           onClick={() => {handleChangeClip(index)}}
                           data-active={clipSelected === index ? '' : undefined}
                           sx={{
                               height: '100%',
                               borderRadius: 2, // arrotonda anche l'area cliccabile
                               '&[data-active]': {
                                   backgroundColor: theme.palette.orange,
                                   '&:hover': {
                                       backgroundColor: 'action.selectedHover',
                                   },
                               },
                           }}
                       >
                           <CardContent
                               sx={{
                                   height: '100%',
                                   color: theme.palette.white,
                               }}
                           >
                               <Typography component="div" sx = {{fontSize: theme.fontSizes.title}}>
                                   {clip.key_moment_type} - {clip.game_time}
                               </Typography>
                               <Typography color={theme.palette.white} variant="body2">
                                   {clip.team}
                               </Typography>
                               <Typography variant="body2" color={theme.palette.white}>
                                   {clip.player}
                               </Typography>
                           </CardContent>
                       </CardActionArea>
                   </Card>

               ))
            }
        </Box>

    )
}